import { useState } from "react";
import RouteDataTiles from "./components/RouteDataTiles";
import RouteDataTable from "./components/RouteDataTable";


type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};


export default function Routes() {
    const [tileData, setTilesData] = useState<ColumnObjType>()
    const handleTiles = (data: ColumnObjType) =>{
      setTilesData(data)
    }

  return (
    <div className="flex flex-col gap-4 mt-4">
      <div className="flex-1">
        <RouteDataTiles  data={tileData}  />
      </div>
      <div className="flex-1 tripTable">
        <RouteDataTable handleTile={handleTiles}  />
      </div>
    </div>

  );
}
